export default {
  instructions: `
    Reproduzca el vídeo para aprender a utilizar My Move. O haga clic en el
    botón <b>Continuar</b> para saltarse estas instrucciones.
  `,
};
